import axios from "axios";
import SweetAlert from 'sweetalert2'

const host = '/api'

export function userRequest() {

  var TOKEN = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))?.accessToken || "NO_TOKEN"
    : "NO_TOKEN";

  // Add a request interceptor
  axios.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      config.baseURL = host
      // config.url = '/api'+config.url
      config.headers.authorization = `Bearer ${TOKEN}`
      return config;
    }
  );

  axios.interceptors.response.use((response) => response,
    function (error) {
      if (error.response?.status === 401) {
        localStorage.setItem("user", null)
        SweetAlert.fire({
          title: "Authentication failure!",
          text: 'You will be redirected to the login page.',
          icon: "error"
        }).then(() => {
          window.location.replace(`${process.env.PUBLIC_URL}/login`)
        }).catch(() => window.location.replace(`${process.env.PUBLIC_URL}/login`))
      }
      return Promise.reject(error);
    }
  );
  return axios
}

export function publicRequest() {
  return axios.create({
    baseURL: host,
  });
}
